// noinspection JSUnresolvedVariable
export default class Company {
  public readonly id: number;
  public readonly name: string;
  public readonly non_mon_accessible: any;
  public readonly non_mon_creation_enabled: any;
  public readonly created_at: any;
  public readonly updated_at: any;

  static fromJson(json: Partial<Company>): Company {
    return Object.assign(new Company(), json);
  }

  getName() {
    return this.name;
  }

  getId() {
    return this.id;
  }

  isNonMonAccessible() {
    return this.non_mon_accessible;
  }

  isNonMonCreationEnabled() {
    return this.non_mon_creation_enabled;
  }
}
